<template>
  <div class="dialog" :class="{ 'active' : showDialog }">
    <div class="dialog--content dialog--medium-width u-extra-medium-padding--top">
      <h4 class="u-extra-small-margin--bottom">{{ $t('generatepdf') }}</h4>
      <p class="u-extra-small-margin--bottom">
        <strong>KW: {{ getWeek() }} ({{ getDate() }})</strong>
      </p>

      <p class="u-extra-small-margin--bottom">{{ $t('weeks.pdf.desc') }}</p>

      <div class="grid-x grid-margin-x u-extra-small-margin--bottom">
        <div
          class="cell small-2 form-group--check u-extra-small-margin--bottom"
          v-for="(item, index) in kolonneItems"
          :key="index"
        >
          <label class="align-left">
            <input type="checkbox" :value="item.kolonne" v-model="selectedKolonne" />
            <i></i>
            {{ item.kolonne }}
          </label>
        </div>
      </div>

      <button
        class="button gray"
        @click.prevent="removeSelections"
      >{{ $t('weeks.button.emptyselection') }}</button>

      <button
        class="button primary"
        :disabled="isLoading && selectedKolonne.length > 0"
        v-on:click.prevent="generatePdf()"
      >{{ $t('form.submit.confirm') }}</button>

      <p
        v-if="message"
        class="u-extra-small-margin--bottom u-extra-small-margin--top"
        :class="error ? 'u-error' : ''"
      >{{ message }}</p>

      <div class="text-center u-extra-small-margin--bottom u-extra-small-margin--top">
        <v-page-loading v-show="isLoading" />
        <div v-if="!isLoading && success === true">
          <a
            :download="zipDownloadFile.file_name"
            :href="zipDownloadFile.file_path"
            target="_blank"
            class="button"
          >{{ zipDownloadFile.file_name }}</a>
        </div>
      </div>
      <button class="close-button" v-on:click.prevent="onCloseDialog()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
import PageLoading from "./../partials/PageLoading";

export default {
  name: "WeekplanPdfDialog",
  components: {
    vPageLoading: PageLoading
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    kolonne: {
      type: Array,
      default: []
    },
    date: {
      type: String | Date,
      default: ""
    }
  },
  model: {
    prop: "showDialog",
    event: "showchange"
  },
  data() {
    return {
      message: "",
      isLoading: false,
      success: false,
      error: false,
      zipDownloadFile: {},
      kolonneItems: [],
      selectedKolonne: []
    };
  },

  computed: {
    showDialog: {
      get: function() {
        if (this.isVisible) {
          this.onOpenDialog();
        }
        return this.isVisible;
      },
      set: function(value) {
        this.$emit("showchange", value);
      }
    }
  },
  methods: {
    removeSelections: function() {
      this.selectedKolonne = [];
    },
    onOpenDialog: function() {
      this.showDialog = true;
      this.pdfUrl = {};
      this.getKolonneItems();
    },

    onCloseDialog: function() {
      this.showDialog = false;
    },

    getKolonneItems: function() {
      let kolonne = [];
      let activeKolonne = [];
      this.kolonne.forEach(item => {
        let newItem = {
          kolonne: item.id,
          selected: true
        };
        kolonne.push(newItem);
        activeKolonne.push(item.id);
      });
      this.kolonneItems = kolonne;
      this.selectedKolonne = activeKolonne;
    },

    generatePdf: function() {
      this.isLoading = true;
      this.error = false;
      this.message = '';

      let body = {
        date: this.$moment(this.date).format("YYYY-MM-DD"),
        kolonne: this.selectedKolonne
      };

      let promise = this.$api.clearParams().post("weekplan/pdf", body);
      return promise
        .then(
          function(response) {
            this.success = true;
            this.zipDownloadFile = {
              file_path:
                process.env.VUE_APP_MEDIA_URL +
                response.data.data.relative_path,
              file_name: response.data.data.file_name
            };
            
          }.bind(this)
        )
        .catch(
          function(error) {
            this.error = true;
            this.message = error;
          }.bind(this)
        )
        .finally(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },

    getDate: function() {
      return this.$moment(this.date).format("DD.MM.YYYY");
    },

    getWeek: function() {
      return this.$moment(this.date).format("w");
    }
  }
};
</script>